import { styled, Box } from '@mui/material';
import Paper from '../../../common/layout/Paper';

export const Container = styled(Box)(({ theme }) => ({
	display: 'flex',
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	justifyContent: 'center',
	alignItems: 'center',
	padding: theme.spacing(3),
	boxSizing: 'border-box',
	backgroundColor: theme.palette.mode === 'dark' ? '#0A0A0A' : '#F5F5F5',
	overflow: 'hidden',
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
	maxWidth: '900px',
	width: '100%',
	height: 'calc(100vh - 120px)',
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
}));

export const StickyHeader = styled(Box)(({ theme }) => ({
	position: 'sticky',
	top: 0,
	zIndex: 10,
	backgroundColor: '#1C1C1C',
	padding: theme.spacing(3),
	paddingBottom: theme.spacing(2),
	borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
}));

export const ScrollableContent = styled(Box)(({ theme }) => ({
	flex: 1,
	overflowY: 'auto',
	overflowX: 'hidden',
	padding: theme.spacing(3),
	paddingTop: theme.spacing(2),
	'&::-webkit-scrollbar': {
		width: '8px',
	},
	'&::-webkit-scrollbar-track': {
		background: 'rgba(255, 255, 255, 0.05)',
		borderRadius: '4px',
	},
	'&::-webkit-scrollbar-thumb': {
		background: 'rgba(255, 255, 255, 0.2)',
		borderRadius: '4px',
		'&:hover': {
			background: 'rgba(255, 255, 255, 0.3)',
		},
	},
}));

export const FixedButtonsContainer = styled(Box)(({ theme }) => ({
	padding: theme.spacing(2, 3),
	borderTop: '1px solid rgba(255, 255, 255, 0.1)',
	backgroundColor: '#1C1C1C',
}));

export const ProfilePhotoContainer = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(2),
	marginBottom: theme.spacing(3),
}));

export const ProfilePhotoUpload = styled(Box)(({ theme }) => ({
	width: '80px',
	height: '80px',
	borderRadius: '50%',
	border: '2px dashed rgba(255, 255, 255, 0.3)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	cursor: 'pointer',
	overflow: 'hidden',
	'&:hover': {
		borderColor: theme.palette.primary.main,
	},
}));

export const ProfileImage = styled('img')({
	width: '100%',
	height: '100%',
	objectFit: 'cover',
});
